import Vue from 'vue';
import Router from 'vue-router';
import { get } from 'lodash';

// Containers
import Full from '@/containers/Full';

// import Empty from '@/views/Empty'

import Login from '@/views/pages/Login';
import Logout from '@/views/pages/Logout';
import Page404 from '@/views/pages/Page404';
import Page403 from '@/views/pages/Page403';
import Tracking from '@/views/pages/Tracking';
import TrackingCustomer from '@/views/pages/TrackingCustomer';
import Empty from '@/views/Empty';
import HawkIframe from '@/components/HawkIframe';

import HawkMap from '@/views/pages/hawk/Map';
import HawkReport from '@/views/pages/hawk/Report';

import AdminRouter from './admin';
import ShipmentMdRouter from './shipment_md';
import ReportRouter from './report';
import DashboardRouter from './dashboard';
import EmployeeRouter from './employee';
import VehicleRouter from './vehicle';
import IssueRouter from './issues';
import PrestartRouter from './question_prestart';
import LocationAccuracyRouter from './location_accuracy';
import CompletionRouter from './completion';
import VehicleGroup from './vehicle_group';
import Profile from './profile';

// import HawkRouter from './hawk';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        DashboardRouter,
        AdminRouter,
        ShipmentMdRouter,
        ReportRouter,
        EmployeeRouter,
        VehicleRouter,
        IssueRouter,
        CompletionRouter,
        PrestartRouter,
        LocationAccuracyRouter,
        VehicleGroup,
        Profile,
        // HawkRouter,
        {
          path: 'dev',
          component: Empty,
          meta: {},
          children: [
            {
              path: '',
              name: 'Dev',
              component: HawkIframe,
            },
          ],
        },
        {
          path: 'hawk_map',
          name: 'Map',
          component: HawkMap,
          meta: {
            filter: userData => get(userData, 'account.hawk_user_token', null) !== null,
          },
        },
        {
          path: 'hawk_report',
          name: 'Hawk Report',
          component: HawkReport,
          meta: {
            filter: userData => get(userData, 'account.hawk_user_token', null) !== null,
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
    },
    {
      path: '/403',
      name: '403 Forbidden',
      component: Page403,
    },
    {
      path: '/tracking',
      name: 'Tracking',
      component: Tracking,
    },
    {
      path: '/tracking_customer',
      name: 'TrackingCustomer',
      component: TrackingCustomer,
    },
    {
      path: '/*',
      name: '404 Not Found',
      component: Page404,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js